export default () => ({
  includes: [],
  pagination: {},
  defaultSearch: {
    limit: 5,
    page: 1,
    pagination: true
  },
  search: {
  }
})



// WEBPACK FOOTER //
// ./src/crud/index/resources/data.js